import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-971436b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "home_content" }
const _hoisted_3 = { class: "filter_box" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "filter_box" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "filter_box" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "filter_box" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "filter_box" }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "filter_box" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "filter_box" }
const _hoisted_16 = { class: "content" }
const _hoisted_17 = { class: "filter_box" }
const _hoisted_18 = { class: "content" }

import { onMounted, ref } from 'vue'
  import Menu from '../../components/Menu.vue'
  import Card from "../../components/Card.vue"
  import {GETAuth} from '@/service/index'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const loading:any = ref(false)
  const ourseKey0 = ref('')
  const courseList = ref()
  const ourseKey1 = ref('')
  const courseList1 = ref([])
  const ourseKey2 = ref('')
  const courseList2 = ref([])
  const ourseKey3 = ref('')
  const courseList3 = ref([])
  const ourseKey4 = ref('')
  const courseList4 = ref([])
  const ourseKey5 = ref('')
  const courseList5 = ref([])
  const ourseKey6 = ref('')
  const courseList6 = ref([])
  const ourseKey7 = ref('')
  const courseList7 = ref([])

  const activeName = ref('TSJ_000')

  onMounted(() => {
    getcourseList({ categorycode: activeName.value })
    // getcourseList({})
    init()
  })

  const filterCourse = (item:any, key:string) => {
    if ( key == '' || item.coursename.indexOf(key) > -1 ) {
      return true
    }
  }

  const init = () => {
    // 加载主摄像头视频模式
    // try {
    //   axios.post("http://127.0.0.1:38088/video=stream&camidx=0").then()
    //   axios.post("http://127.0.0.1:38088/video=stream&camidx=1").then()
    // } catch (error) {
    //   console.log(1)
    // }
  }

  const handleClick = () => {
    getcourseList({ categorycode: activeName.value })
  }
  

  const getcourseList = async ( params: any ) => {
    if ( params.categorycode && params.categorycode === 'TSJ_000' ) {
      delete params.categorycode
    }
    if ( params.categorycode === 'TSJ_000' &&  courseList.value.length > 0)  return;
    if ( params.categorycode === 'TSJ_001' &&  courseList1.value.length > 0)  return;
    if ( params.categorycode === 'TSJ_002' &&  courseList2.value.length > 0)  return;
    if ( params.categorycode === 'TSJ_003' &&  courseList3.value.length > 0)  return;
    if ( params.categorycode === 'TSJ_004' &&  courseList4.value.length > 0)  return;
    if ( params.categorycode === 'TSJ_005' &&  courseList5.value.length > 0)  return;
    if ( params.categorycode === 'TSJ_006' &&  courseList6.value.length > 0)  return;
    if ( params.categorycode === 'TSJ_007' &&  courseList7.value.length > 0)  return;

    loading.value = true
    let res:any  = await GETAuth(`/common/course_all`, {
      params: params
    })
    loading.value = false
    let data = res.data
    if ( data.code === 200 ) {
      data.data.forEach((element:any) => {
        element.imageurl = `/out${element.imageurl}`
      });
      if ( params.categorycode === 'TSJ_001' ) {
        courseList1.value = data.data
      } else if ( params.categorycode === 'TSJ_002' ) {
        courseList2.value = data.data
      } else if ( params.categorycode === 'TSJ_003' ) {
        courseList3.value = data.data
      } else if ( params.categorycode === 'TSJ_004' ) {
        courseList4.value = data.data
      } else if ( params.categorycode === 'TSJ_005' ) {
        courseList5.value = data.data
      } else if ( params.categorycode === 'TSJ_006' ) {
        courseList6.value = data.data
      } else if ( params.categorycode === 'TSJ_007' ) {
        courseList7.value = data.data
      } else {
        courseList.value = data.data
      }
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Menu, { index: "1" }),
      _createVNode(_component_el_tabs, {
        type: "border-card",
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((activeName).value = $event)),
        class: "demo-tabs",
        onTabChange: handleClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "全部课程",
            name: "TSJ_000"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_form, {
                  inline: true,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课程名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: ourseKey0.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ourseKey0).value = $event)),
                          style: {"width":"200px"},
                          clearable: "",
                          placeholder: "请输入课程名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { height: "650px" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, (item, index) => {
                      return (_openBlock(), _createBlock(Card, {
                        isShow: filterCourse(item,ourseKey0.value),
                        key: index,
                        item: item
                      }, null, 8, ["isShow", "item"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "安全管理",
            name: "TSJ_001"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_form, {
                  inline: true,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课程名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: ourseKey1.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ourseKey1).value = $event)),
                          clearable: "",
                          placeholder: "请输入安全管理类课程名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { height: "650px" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList1.value, (item, index) => {
                      return (_openBlock(), _createBlock(Card, {
                        isShow: filterCourse(item,ourseKey1.value),
                        key: index,
                        item: item
                      }, null, 8, ["isShow", "item"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "职业卫生",
            name: "TSJ_002"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_form, {
                  inline: true,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课程名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: ourseKey2.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ourseKey2).value = $event)),
                          clearable: "",
                          placeholder: "请输入职业卫生类课程名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { height: "650px" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList2.value, (item, index) => {
                      return (_openBlock(), _createBlock(Card, {
                        isShow: filterCourse(item,ourseKey2.value),
                        key: index,
                        item: item
                      }, null, 8, ["isShow", "item"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "特种作业",
            name: "TSJ_003"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_form, {
                  inline: true,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课程名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: ourseKey3.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ourseKey3).value = $event)),
                          clearable: "",
                          placeholder: "请输入特种作业类课程名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { height: "650px" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList3.value, (item, index) => {
                      return (_openBlock(), _createBlock(Card, {
                        isShow: filterCourse(item,ourseKey3.value),
                        key: index,
                        item: item
                      }, null, 8, ["isShow", "item"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "特种设备",
            name: "TSJ_004"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_form, {
                  inline: true,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课程名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: ourseKey4.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ourseKey4).value = $event)),
                          clearable: "",
                          placeholder: "请输入特种设备类课程名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { height: "650px" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList4.value, (item, index) => {
                      return (_openBlock(), _createBlock(Card, {
                        isShow: filterCourse(item,ourseKey4.value),
                        key: index,
                        item: item
                      }, null, 8, ["isShow", "item"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "其他培训",
            name: "TSJ_005"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_form, {
                  inline: true,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课程名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: ourseKey5.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ourseKey5).value = $event)),
                          clearable: "",
                          placeholder: "请输入其他培训类课程名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { height: "650px" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList5.value, (item, index) => {
                      return (_openBlock(), _createBlock(Card, {
                        isShow: filterCourse(item,ourseKey5.value),
                        key: index,
                        item: item
                      }, null, 8, ["isShow", "item"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "应急救援员",
            name: "TSJ_006"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_form, {
                  inline: true,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课程名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: ourseKey6.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ourseKey6).value = $event)),
                          clearable: "",
                          placeholder: "请输入应急救援员类课程名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { height: "650px" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList6.value, (item, index) => {
                      return (_openBlock(), _createBlock(Card, {
                        isShow: filterCourse(item,ourseKey6.value),
                        key: index,
                        item: item
                      }, null, 8, ["isShow", "item"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "消防设施操作员",
            name: "TSJ_007"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_form, {
                  inline: true,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "课程名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: ourseKey7.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ourseKey7).value = $event)),
                          clearable: "",
                          placeholder: "请输入消防设施操作员类课程名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { height: "650px" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList7.value, (item, index) => {
                      return (_openBlock(), _createBlock(Card, {
                        isShow: filterCourse(item,ourseKey7.value),
                        key: index,
                        item: item
                      }, null, 8, ["isShow", "item"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})